import styled from 'styled-components';

import { media } from '@utils/styled';

export const Container = styled.div`
  display: flex;
  justify-content: center;

  ${media.from480up`
    display: none;
  `};
`;

export const FloatingContainer = styled.div`
  display: flex;
  ${({ theme }) => theme.getFluidSpacing('bottom', 'widthBased', 0)};
`;

export const CustomButtons = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto auto;
  ${({ theme }) => theme.getFluidSpacing('grid-gap', 'equal', 3)};
  height: min-content;
  box-shadow: ${({ theme }) => theme.shadows[0]};
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}rem;
  background: white;
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'equal', 4)};
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'equal', 3)};
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'equal', 4)};
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'equal', 3)};
`;

export const CustomButton = styled.button`
  width: 2rem;
  height: 2rem;
  outline: none;
  border: 0;
  padding: 0;
  background: none;
  cursor: pointer;

  svg {
    width: 2rem;
    height: 2rem;
  }
`;
